import { Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { FC, ReactNode } from 'react'
import { theme } from '../../../../theme'

interface Props {
    title: string
    description: string
    icon: ReactNode
}

const ReferralProgramStep: FC<Props> = ({ title, description, icon }) => {
    return (
        <Grid
            sx={{
                padding: '20px',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                backgroundColor: '#F9FAFB',
                [theme.breakpoints.down('md')]: {
                    alignItems: 'flex-start',
                },
            }}>
            <Grid
                sx={{
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                }}>
                {icon}
            </Grid>
            <Grid>
                <Typography marginBottom={1} variant="h6">
                    {title}
                </Typography>
                <Typography variant="body2">{description}</Typography>
            </Grid>
        </Grid>
    )
}

export default ReferralProgramStep
